import Hashtags from './Hashtags';

export default Hashtags;
